<template>
  <screen v-show="show" :screen-info="$t('footscan.barefoot')" @skip="$emit('skip')">
    <img src="../../assets/FootScan/socks-or-barefoot.svg" :alt="$t('footscan.barefoot')" />
  </screen>
</template>

<script>
import autoNext from '@/mixins/auto-next';
import Screen from '../common/Screen.vue';

export default {
  name: 'Barefoot',
  mixins: [autoNext],
  components: {
    Screen,
  },
  data: () => ({
    playThroughGap: 3,
    audioKey: 'foot_barefoot',
  }),
};
</script>

<style scoped></style>
